import {
  SlCopyButton
} from "./chunk.HFMTIKY4.js";

// src/components/copy-button/copy-button.ts
var copy_button_default = SlCopyButton;
SlCopyButton.define("sl-copy-button");

export {
  copy_button_default
};
